function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRadioMultiQuestionToTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4daccb",
      fillOpacity: 1
    },
    d: "M 7.304688 15.894531 C 4.015625 15.894531 1.394531 18.515625 1.394531 21.75 C 1.394531 24.984375 4.015625 27.660156 7.304688 27.660156 C 10.539062 27.660156 13.21875 25.039062 13.21875 21.75 C 13.160156 18.515625 10.539062 15.894531 7.304688 15.894531 Z M 7.304688 25.039062 C 5.519531 25.039062 4.015625 23.589844 4.015625 21.75 C 4.015625 19.910156 5.464844 18.460938 7.304688 18.460938 C 9.144531 18.460938 10.597656 19.910156 10.597656 21.75 C 10.597656 23.589844 9.089844 25.039062 7.304688 25.039062 Z M 7.304688 25.039062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4daccb",
      fillOpacity: 1
    },
    d: "M 21.695312 15.894531 C 18.460938 15.894531 15.78125 18.515625 15.78125 21.804688 C 15.78125 25.039062 18.402344 27.71875 21.695312 27.71875 C 24.929688 27.71875 27.605469 25.097656 27.605469 21.804688 C 27.605469 18.515625 24.984375 15.894531 21.695312 15.894531 Z M 21.695312 15.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4daccb",
      fillOpacity: 1
    },
    d: "M 7.304688 1.394531 C 4.015625 1.394531 1.394531 4.015625 1.394531 7.304688 C 1.394531 10.539062 4.015625 13.21875 7.304688 13.21875 C 10.539062 13.21875 13.21875 10.597656 13.21875 7.304688 C 13.160156 4.015625 10.539062 1.394531 7.304688 1.394531 Z M 7.304688 10.539062 C 5.519531 10.539062 4.015625 9.089844 4.015625 7.25 C 4.015625 5.410156 5.464844 3.960938 7.304688 3.960938 C 9.144531 3.960938 10.597656 5.410156 10.597656 7.25 C 10.597656 9.089844 9.089844 10.539062 7.304688 10.539062 Z M 7.304688 10.539062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4daccb",
      fillOpacity: 1
    },
    d: "M 21.695312 1.394531 C 18.460938 1.394531 15.78125 4.015625 15.78125 7.304688 C 15.78125 10.539062 18.402344 13.21875 21.695312 13.21875 C 24.929688 13.21875 27.605469 10.597656 27.605469 7.304688 C 27.605469 4.015625 24.984375 1.394531 21.695312 1.394531 Z M 21.695312 1.394531 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRadioMultiQuestionToTable);
export default __webpack_public_path__ + "static/media/iconRadioMultiQuestionToTable.58de17edff6f20e3d20c89520274685a.svg";
export { ForwardRef as ReactComponent };